function calculateDate(sec) {
    if (sec <= 0) {
        return {
            time: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            dataSet: {
                days: 'дней',
                hours: 'часов',
                minutes: 'минут',
                seconds: 'секунд'
            }
        };
    }
    var time = {
        days: Math.floor(sec / 60 / 60 / 24),
        hours: Math.floor(sec / 60 / 60) % 24,
        minutes: Math.floor(sec / 60) % 60,
        seconds: Math.floor(sec % 60)
    };
    var dataSet = {
        days: time.days ? declensionWord(time.days, ['день', 'дня', 'дней']) : '',
        hours: time.hours ? declensionWord(time.hours, ['час', 'часа', 'часов']) : '',
        minutes: time.minutes ? declensionWord(time.minutes, ['минута', 'минуты', 'минут']) : '',
        seconds: time.seconds ? declensionWord(time.seconds, ['секунда', 'секунды', 'секунд']) : ''
    };
    return {
        dataSet: dataSet,
        time: time,
    };
}

function countDownTimer(sec) {
    var _calculateDate = calculateDate(sec),
        dataSet = _calculateDate.dataSet,
        time = _calculateDate.time;
    return {
        time: time,
        dataSet: dataSet,
    }
}

function startTimer(sec, cb, endCb) {
    var timerId = setInterval(function () {
        if (sec < 0) {
            clearInterval(timerId)
            endCb()
            return;
        }
        cb(countDownTimer(--sec))
    }, 1000);
    return timerId
}

